import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ExternalUserLayout } from '~/ui/layouts/ExternalUserLayout';

function ExternalLayout() {
  return (
    <ExternalUserLayout>
      <Outlet />
    </ExternalUserLayout>
  );
}

export const Route = createFileRoute('/(custom)/external')({
  component: ExternalLayout,
});
